<template>
    <div id="listing-view">
        <flash-message transitionIn="animated swing"></flash-message>
        <b-row>
            <b-col xs="12" lg="12">
                <b-card>
                    <div slot="header">
                       Membership: {{ membership.person.name }} {{ membership.person.surname }} ( {{ membership.startAt|moment("DD/MM/YYYY") }} - {{ membership.endAt|moment("DD/MM/YYYY") }})
                    </div>
                    <membership-form :membership="membership"></membership-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>

    import {Membership} from "../../models/Membership";
    import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
    import MembershipForm from "../../components/membership/MembershipForm";

    export default {
        name: 'Membership',
      components: {MembershipForm},
      data() {
            return {
                membership: new Membership()
            }
        },
        mounted () {
          RepositoryFactory
            .get('membership')
            .getMember(this.$route.params.memberId)
            .then(
              response => (
                this.membership = new Membership(response.data.data)
              )
            )
        }
    }
</script>
